import React, { useEffect, useState } from 'react';
import { Container, CustomInput, InputError, InputContainer } from './styles';
import OptionInput from '../../../commons/OptionInput';
import { useTranslation } from 'react-i18next';

const AntiquitySection = ({
  currentAntiquity = '',
  updateReduxState = () => {},
  setAntiquityType = () => {},
  antiquityType = null,
  isMobile,
  hasError,
  isDepartment = false
}) => {
  const [showInput, setShowInput] = useState(false);
  const { t } = useTranslation();

  useEffect(() => {
    setShowInput(antiquityType === antiquityOptionsValues.USADO);
    if (currentAntiquity !== '' || antiquityType !== null) {
      updateCurrentAntiquity(antiquityType, currentAntiquity);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [antiquityType, currentAntiquity]);

  const antiquityOptionsValues = {
    EN_CONSTRUCCION: '1',
    A_ESTRENAR: '2',
    USADO: '3'
  };

  const updateCurrentAntiquity = (antiquityType, currentAntiquity) => {
    if (antiquityType === antiquityOptionsValues.EN_CONSTRUCCION) {
      return updateReduxState(-1);
    }
    if (antiquityType === antiquityOptionsValues.A_ESTRENAR) {
      return updateReduxState(0);
    }
    updateReduxState(currentAntiquity > 0 ? currentAntiquity : '');
  };

  const antiquityOptions = [
    {
      label: t('professionalPubli.features.antiquity.op1'),
      keyName: 'EN_CONSTRUCCION',
      typeId: antiquityOptionsValues.EN_CONSTRUCCION
    },
    {
      label: t('professionalPubli.features.antiquity.op2'),
      keyName: 'A_ESTRENAR',
      typeId: antiquityOptionsValues.A_ESTRENAR
    },
    { label: t('professionalPubli.features.antiquity.op3'), keyName: 'USADO', typeId: antiquityOptionsValues.USADO }
  ];

  const handleChange = e => {
    const optionIdSelected = e.target.value;
    setAntiquityType(optionIdSelected);
  };

  return (
    <Container isMobile={isMobile}>
      {antiquityOptions.map(({ typeId, label, keyName }) => {
        if (isDepartment && typeId === antiquityOptionsValues.EN_CONSTRUCCION) {
          return null; // Skip "En Construcción" option for departments
        }
        return (
          <OptionInput
            key={typeId}
            type='checkbox'
            name='operationType'
            value={typeId}
            selected={antiquityType === typeId}
            onChange={handleChange}
            label={label}
            dataPubli={`publi-antiquityOption-${keyName}`}
          />
        );
      })}
      <InputContainer>
        <CustomInput
          data-publi={`publi-antiquityOption-input-years`}
          hasError={hasError}
          isMobile={isMobile}
          showInput={showInput}
          placeholder={t('professionalPubli.features.antiquity.placeholder')}
          value={currentAntiquity}
          onChange={e => {
            const value = e.target.value;
            if (value.length <= 3) {
              updateReduxState(value);
            }
          }}
          type='number'
        />
        {hasError && showInput && (
          <InputError data-publi={`publi-antiquityOption-input-years-error`} isMobile={isMobile}>
            {hasError}
          </InputError>
        )}
      </InputContainer>
    </Container>
  );
};

export default AntiquitySection;
